import Grid from '@mui/material/Grid';
//import Typography from '@mui/material/Typography';
import CardMarkerSmall from '../../../../../components/CockpitCards/CardMarkerSmall';
import DiaGetClockData from './DiaGetClockData';
import DiaClockInfo from './DiaClockInfo';
import { useTheme } from "@mui/material";

import BloodSubCard from './DriverGauges/Blood/BloodSubCard';
import BrainSubCard from './DriverGauges/Brain/BrainSubCard';
import InflammationSubCard from './DriverGauges/Inflammation/InflammationSubCard';
import HeartSubCard from './DriverGauges/Heart/HeartSubCard';
import HormoneSubCard from './DriverGauges/Hormone/HormoneSubCard';
import ImmuneSubCard from './DriverGauges/Immune/ImmuneSubCard';
import KidneySubCard from './DriverGauges/Kidney/KidneySubCard';
import LiverSubCard from './DriverGauges/Liver/LiverSubCard';
import MetabolicSubCard from './DriverGauges/Metabolic/MetabolicSubCard';
import LungSubCard from './DriverGauges/Lung/LungSubCard'
import MuscoSubCard from './DriverGauges/Musco/MuscoSubCard';

export default function DriverCard() {

  const theme = useTheme();
  
return(
<>

{theme.palette.mode === "light" ? (

<CardMarkerSmall

headline = "AGING DRIVERS" 
subtext = {"How old are your organ systems biologically compared to your chronological age? In this section we go one level deeper uncovering personal aging drivers." }
  

list = { <DiaGetClockData /> }
info = { <DiaClockInfo /> }

cardlines = {<>

<Grid container>
  
  <Grid size={12}> <BloodSubCard /> </Grid>
  <Grid size={12}> <BrainSubCard /> </Grid>
  <Grid size={12}> <InflammationSubCard /> </Grid>
  <Grid size={12}> <HeartSubCard /> </Grid>
  <Grid size={12}> <HormoneSubCard /> </Grid>
  <Grid size={12}> <ImmuneSubCard /> </Grid>
  <Grid size={12}> <KidneySubCard /> </Grid>
  <Grid size={12}> <LiverSubCard /> </Grid>
  <Grid size={12}> <MetabolicSubCard /> </Grid>
  <Grid size={12}> <LungSubCard /> </Grid>
  <Grid size={12}> <MuscoSubCard /> </Grid>
</Grid>
</>}
/>  

) : (

  <CardMarkerSmall

headline = "BIO AGE" 
subtext = {"How old are you really? Biomarkers of aging and aging clocks are an essential part of aging research as aging is recognized as a fundamental driver of chronic diseases and mortality. Aging clocks are relatively new but groundbreaking in the aging science. Clocks not only tell you how old you really are (biological age versus chronological age), but also serve as monitor for the effectiveness of interventions in the aging process and preventive treatments for age-related diseases." }
  

list = { <DiaGetClockData /> }
info = { <DiaClockInfo /> }

cardlines = {<>

<Grid container>
  
  <Grid size={12}> <BloodSubCard /> </Grid>
  <Grid size={12}> <BrainSubCard /> </Grid>
  <Grid size={12}> <InflammationSubCard /> </Grid>
  <Grid size={12}> <HeartSubCard /> </Grid>
  <Grid size={12}> <HormoneSubCard /> </Grid>
  <Grid size={12}> <ImmuneSubCard /> </Grid>
  <Grid size={12}> <KidneySubCard /> </Grid>
  <Grid size={12}> <LiverSubCard /> </Grid>
  <Grid size={12}> <MetabolicSubCard /> </Grid>
  <Grid size={12}> <LungSubCard /> </Grid>
  <Grid size={12}> <MuscoSubCard /> </Grid>

</Grid>
 
</>}
/>  

)}

</>
)
}

